import _classCallCheck from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/inherits";
// import EventEmitter from 'events';
import BrowserTransport from './spin/transports/browser';
import CollectionModel from './CollectionModel'; // import SingletonModel from './SingletonModel';

import Spin from './spin/spin';
import Listener from './Listen';
import State from './State';
import Store from './Store';
import logger from './logger';
import Color from './Color';
import Sound from './Sound'; // import AudioScope from './AudioScope';

import MonauralScope from './MonauralScope';
global.Spin = Spin;
var spinBrowser = new BrowserTransport(Spin);

function postMessage(msg) {
  console.log('client post', msg);
  var data = {
    '_jaxcore_client': {
      message: msg,
      protocol: 1
    }
  }; // if (msg.spin) {
  // 	console.log(data);
  // 	debugger;
  // }

  window.postMessage(data, window.document.location.protocol + window.document.location.host);
}

var Listen = new Listener(postMessage); //.setPostCommand();

spinBrowser.setPostCommand(postMessage);

var JaxcoreClient =
/*#__PURE__*/
function (_State) {
  _inherits(JaxcoreClient, _State);

  function JaxcoreClient() {
    var _this;

    _classCallCheck(this, JaxcoreClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JaxcoreClient).call(this));
    _this.reconnect = true;

    _this.setState({
      connectedExtension: false,
      extensionReady: false
    });

    var onMessage = function onMessage(event) {
      //event.isTrusted &&
      if (document.location.href.indexOf(event.origin) === 0) {
        if (event.data._jaxcore_content) {
          var msg = event.data._jaxcore_content.message;

          if (msg.socketDisconnected) {
            _this.setState({
              connectedExtension: false
            });
          } else if ('extensionReady' in msg) {
            //console.log('extensionReady', msg);
            _this.setState({
              extensionReady: true
            });

            _this.emit('extension-ready'); // debugger;

          } else if ('connectedExtension' in msg) {
            _this.setState({
              connectedExtension: msg.connectedExtension
            });

            if (msg.connectedExtension) {
              //callback(null, true);
              console.log('connectedExtension !');

              _this.emit('connectedExtension');
            } else {// this.connectExtension();
            }
          } else if (msg.spin) {
            console.log('got spin data from bg', msg.spin);
            spinBrowser.data(msg.spin);
          } else if (msg.listen) {
            console.log('got listen data from bg', msg.spin); //alert('Listen said: ' + msg.listen.recognizedText);
            // spinBrowser.data(msg.spin);

            Listen.recognizedText(msg.listen.recognizedText);
          } else if (event.data.target && event.data.target === 'inpage') {} else {
            console.log('client unhandled message', event.data);
          }
        } else {// console.log('not _jaxcore_content', event.data, event.origin);
        }
      } else {
        console.log('nope', event);
      }
    };

    window.addEventListener("message", onMessage);
    spinBrowser.on('command', function (spin, args) {
      console.log('spin command', spin, args);
    });
    return _this;
  }

  _createClass(JaxcoreClient, [{
    key: "disconnectExtension",
    value: function disconnectExtension() {
      this.reconnect = false; // console.log('disconnectExtension');

      postMessage({
        disconnectExtension: true
      });
    }
  }, {
    key: "connect",
    value: function connect(callback) {
      var _this2 = this;

      this.once('connectedExtension', callback);

      if (this.state.extensionReady) {
        this.connectExtension();
      } else {
        this.once('extension-ready', function () {
          _this2.connectExtension();
        });
      }
    }
  }, {
    key: "connectExtension",
    value: function connectExtension(callback) {
      if (this.state.connectedExtension) {
        console.log('already connectedExtension');
        this.emit('connectedExtension');
      } else {
        // TO DO CHANGE TO LISTENER ?
        console.log('Jaxcore connectExtension');
        postMessage({
          connectExtension: true
        });
      }
    }
  }, {
    key: "connectSpins",
    value: function connectSpins(callback) {
      var _this3 = this;

      console.log('connectSpins');
      spinBrowser.addListener('spin-created', function (spin) {
        callback(spin);
      });

      if (this.state.extensionReady) {
        this.connectExtension();
      } else {
        this.once('extension-ready', function () {
          _this3.connectExtension();
        });
      } // if (this.state.connectedExtension) {
      //
      // }
      //
      // if (this.state.connectedExtension) {
      // 	this.onCreate(callback);
      // } else {
      // 	this.once('connectedExtension', () => {
      // 		this.onCreate(callback);
      // 	});
      // 	// setTimeout(() => {
      // 		this.connectExtension(callback);
      // 	// }, 1000);
      // }

    }
  }, {
    key: "onCreate",
    value: function onCreate(callback) {
      var _this4 = this;

      spinBrowser.addListener('spin-created', function (spin) {
        _this4.emit(); // if (spin.state.connected) {
        // 	callback(spin);
        // } else {
        // 	spin.once('connected', function () {
        // 		callback(spin)
        // 	});
        // }

      });
    }
  }]);

  return JaxcoreClient;
}(State);

var createStore = function createStore(name) {
  return new Store(name);
};

var createLogger = logger.create;
export { CollectionModel, State, Store, createStore, logger, createLogger, Color, Sound, Spin, Listen, MonauralScope };
var jaxcore = new JaxcoreClient();
Spin.connectAll = jaxcore.connectSpins.bind(jaxcore); // todo: refactor this in a better way

export default jaxcore; // var Client = require('./client');
// // var ES6Client = require('./es6client');
//
// module.exports = {
// 	logger: logger,
// 	createLogger: logger.create,
// 	Store: Store,
// 	createStore: function(name) {
// 		return new Store(name);
// 	},
// 	Client: Client
// 	// ES6Client: ES6Client
// };